import React from 'react';
import { IconCross } from '@components/icons/icon-cross';

import { CloseButtonProps } from './close-button.type';

export const CloseButton = ({ id, handleClose, dataTestId }: CloseButtonProps) => {
  return (
    <button
      id={id}
      type='button'
      onClick={handleClose}
      className='focus:ring-0 focus:outline-hidden'
      data-testid={dataTestId}
      aria-label='Close modal'>
      <IconCross className='text-primary w-6 h-6' />
    </button>
  );
};
